import {
	GetUserSettingsQuery,
	LoyaltyCardInput,
	NewTravellerParameters,
	Profile_UserProfile_Fragment,
	TravellerDocumentInput,
	TravellerFieldEnum,
	UserFragment,
	UserProfileParameters
} from '@websky/graphql';
import { UserSettings, ActionRoute, PathRoute, Route } from './types';
import { matchPath } from 'react-router';

export const getUserSettingsByName = (userSettings: GetUserSettingsQuery['UserSettings'], name: UserSettings) => {
	return userSettings?.find(value => value.name === name)?.value;
};

export const isMailSubscriptionVisible = (
	showSubscribeCheckbox: boolean,
	subscribeSettingValue: string,
	userEmail: string
): boolean => {
	return Boolean(showSubscribeCheckbox && subscribeSettingValue && userEmail);
};

export const mergeTravellerDocuments = (
	initialDocuments: TravellerDocumentInput[],
	newDocuments: TravellerDocumentInput[]
) =>
	(newDocuments?.length ? newDocuments : initialDocuments).map(document => {
		const { __typename = undefined, ...exactdocument } = document as any;

		return exactdocument as TravellerDocumentInput;
	});

export const mergeLoyaltyCards = (
	initialLoyaltyCards: Profile_UserProfile_Fragment['loyaltyCards'],
	newLoyaltyCards: LoyaltyCardInput[]
): LoyaltyCardInput[] => {
	if (!newLoyaltyCards?.length && !initialLoyaltyCards?.length) {
		return [];
	}

	return newLoyaltyCards?.length
		? newLoyaltyCards
		: [
				{
					airlineCode: initialLoyaltyCards?.[0]?.values?.find(
						value => value.type === TravellerFieldEnum.LoyaltyAirline
					)?.value,
					cardNumber: initialLoyaltyCards[0].number
				}
		  ];
};

export const mergeUserData = (
	user: UserFragment,
	newFields: Partial<NewTravellerParameters>
): UserProfileParameters => {
	const { values: userValues, id, documents: userDocuments, ...userFieldsToApi } = user;

	const initialDocuments: TravellerDocumentInput[] = userDocuments.map(
		({ values, ...rest }) => rest as TravellerDocumentInput
	);

	const documents = mergeTravellerDocuments(initialDocuments, newFields.documents);
	const loyaltyCards = mergeLoyaltyCards(userFieldsToApi.loyaltyCards, newFields.loyaltyCards);

	if ('__typename' in userFieldsToApi) {
		delete (userFieldsToApi as any).__typename;
	}

	return {
		...userFieldsToApi,
		...newFields,
		documents,
		loyaltyCards
	};
};

export const isPathRoute = (route: Route): route is PathRoute => {
	return (route as PathRoute).pathname !== undefined;
};

export const isActionRoute = (route: Route): route is ActionRoute => {
	return (route as ActionRoute).action !== undefined;
};

export const isRouteSelected = (route: Route, selectedRoute: string) => {
	const match =
		isPathRoute(route) &&
		matchPath(selectedRoute, {
			path: route.pathname,
			exact: !route.hasChild
		});

	return !!match;
};
